import { useLanguage } from './hooks';

/**
 * Hook to get RTL/LTR utility classes for selective application
 */
export const useRTLUtils = () => {
  const { isRTL } = useLanguage();

  return {
    isRTL,
    directionClass: isRTL ? 'rtl' : 'ltr',
    textAlignClass: isRTL ? 'text-right' : 'text-left',
    marginStartClass: isRTL ? 'mr-auto' : 'ml-auto',
    marginEndClass: isRTL ? 'ml-auto' : 'mr-auto',
    paddingStartClass: isRTL ? 'pr-4' : 'pl-4',
    paddingEndClass: isRTL ? 'pl-4' : 'pr-4',
  };
};

/**
 * Utility function to conditionally apply RTL/LTR classes
 */
export const getRTLClass = (isRTL: boolean, ltrClass: string, rtlClass: string) => {
  return isRTL ? rtlClass : ltrClass;
};

/**
 * Utility function to get direction-aware spacing classes
 */
export const getRTLSpacingClass = (isRTL: boolean, baseClass: string) => {
  if (isRTL) {
    return `${baseClass} rtl`;
  }
  return baseClass;
};
